import * as React from "react";
const IconSpinnerArrow = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M58.2 26.8c-.4-1.2-1.6-1.8-2.8-1.5-1.2.4-1.8 1.6-1.5 2.8.7 2.2 1.1 4.5 1.1 6.8 0 3.5-.8 6.8-2.3 9.9-3.9 8-11.8 13-20.7 13C19.3 57.8 9 47.5 9 35s10.3-22.8 23-22.8c2.3 0 4.6.3 6.7 1l-3.4 1.6c-1.1.5-1.6 1.9-1.1 3 .4.8 1.2 1.3 2 1.3.3 0 .6-.1.9-.2l8.8-4.1c.5-.3 1-.7 1.2-1.3s.2-1.2-.1-1.7L43 3c-.5-1.1-1.9-1.6-3-1.1s-1.6 1.9-1.1 3l1.9 4.2c-2.8-1-5.8-1.5-8.9-1.5C16.9 7.7 4.5 19.9 4.5 35S16.9 62.3 32 62.3c10.6 0 20.1-5.9 24.7-15.4 1.8-3.7 2.8-7.7 2.8-11.9 0-2.8-.5-5.6-1.3-8.2" />
  </svg>
);
export default IconSpinnerArrow;
